// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".interactive-bg[data-v-1434bb43]{background-color:rgba(0,123,255,.05);padding:2px 5px;border-radius:3px;transition:background-color .2s ease}.interactive-bg[data-v-1434bb43]:hover{background-color:rgba(0,123,255,.1)}", ""]);
// Exports
module.exports = exports;
